var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatternOverviewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_181_50954)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6637 14.6032C16.188 13.8675 16.5 12.9705 16.5 12C16.5 9.519 14.481 7.5 12 7.5C9.519 7.5 7.5 9.519 7.5 12C7.5 14.481 9.519 16.5 12 16.5C12.9705 16.5 13.8675 16.188 14.6032 15.6637L16.6042 17.6647L17.6647 16.6042L15.6637 14.6032ZM12 14.25C9.921 14.25 8.91225 12.5812 8.625 12C8.91375 11.4172 9.921 9.75 12 9.75C14.079 9.75 15.0862 11.4172 15.375 12C15.0862 12.5827 14.079 14.25 12 14.25Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3105 0H2.25C1.0095 0 0 1.0095 0 2.25V18H10.5V17.7945C9.576 17.556 8.736 17.112 8.04075 16.5H1.5V2.25C1.5 1.836 1.83675 1.5 2.25 1.5H8.25V6.75H15V5.6895L9.3105 0ZM9.75 5.25V2.5605L12.4395 5.25H9.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_181_50954"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "currentColor"
})))));
export default SvgPatternOverviewIcon;